import { useEffect } from "react";
import { AuthLoginEmail } from "./AuthLoginEmail";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

export const AuthLoginEmailWithRecaptcha = (props) => {
  const key = process.env.REACT_APP_CAPTCHA_SITE_KEY;

  // Clean up script & badge when leaving login page
  useEffect(() => {
    return () => {
      const script = document.querySelector('script[src*="recaptcha"]');
      if (script) script.remove();

      const badge = document.querySelector(".grecaptcha-badge");
      if (badge) badge.remove();

      // Remove global grecaptcha
      if (window.grecaptcha) delete window.grecaptcha;
    };
  }, []);

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={key || "missing-key"}
      scriptProps={{
        async: true,
        defer: true,
        appendTo: "head",
      }}
      container={{
        parameters: {
          render: key,
        },
      }}
      autoResetOnExpire={false}
    >
      <AuthLoginEmail {...props} />
    </GoogleReCaptchaProvider>
  );
};
